
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonlinecabbooking() {



    const cardData =
    {
        keyword: 'Pune Online Cab Booking',
        heading: 'Platinum24 Cabs: Pune Online Cab Booking',
        headingDescription: 'Platinum24 Cabs makes Pune Online Cab Booking simple, fast, and reliable for all types of travel. Whether you’re booking a local city ride, airport transfer, or outstation cab, our user-friendly online system ensures instant confirmations and transparent fares. With a wide range of hatchbacks, sedans, SUVs, and luxury cars, you can choose the right cab that fits your travel style and budget. Our professional drivers, timely service, and 24/7 support guarantee a smooth booking experience. From business trips to family travel, Platinum24 Cabs brings convenience and comfort right at your fingertips.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

        "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace and a proud symbol of Maratha heritage. Its massive gates, fountains, and courtyards echo tales of the Maratha Empire. Though partially destroyed by fire in 1828, it still attracts thousands of tourists daily. The light-and-sound show narrates the story of Bajirao and Mastani. Visitors enjoy exploring its ruins and lush gardens. Shaniwar Wada is Pune’s cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is an important landmark in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings and photographs. The palace’s Italian arches and sprawling gardens make it a peaceful retreat. Tourists admire both its historic and architectural significance. Aga Khan Palace is Pune’s proud heritage of patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hill fortress famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb the rugged paths for panoramic views of the Sahyadri ranges. The fort’s gates, bastions, and temples narrate stories of bravery. Monsoon brings mist, greenery, and waterfalls, making it especially scenic. Local vendors serve traditional pithla-bhakri at the top. Sinhagad Fort is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established over 125 years ago, the grand idol adorned with gold ornaments is a divine sight. During Ganesh Chaturthi, the temple becomes the epicenter of celebrations, attracting lakhs of devotees. The temple is also known for its charitable and cultural initiatives. Its spiritual aura makes it a must-visit for pilgrims and tourists. Dagdusheth is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa showcase ancient Indian craftsmanship. Located in the heart of the city, it offers peace and spiritual calm amidst urban chaos. Evening prayers add to its mystical atmosphere. History enthusiasts admire its simple yet powerful design. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. It includes ornaments, sculptures, musical instruments, and household antiques. A highlight is the recreated Mastani Mahal, reflecting the Maratha era’s grandeur. Students and art lovers find it educational and fascinating. The museum preserves India’s traditions under one roof. It is Pune’s proud showcase of history and culture."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop temple complex, built by the Peshwas, is dedicated to Lord Shiva and Goddess Parvati. Smaller shrines and a museum add to its heritage significance. Visitors climb 103 steps to reach the temple, combining devotion with scenic charm. Sunrises and sunsets from the top are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for spirituality and wellness. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation, yoga, and personal growth workshops. Japanese Zen gardens and serene meditation halls enhance the experience. It is both a wellness retreat and a spiritual destination. Osho Ashram is Pune’s international hub of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a favorite for families and nature lovers. Seasonal flowers and lush greenery make it picturesque year-round. Families enjoy picnics, photography, and peaceful strolls here. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s green paradise of beauty and calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates a spectacular sight. Families enjoy roadside snacks like roasted corn and hot tea here. It is also the gateway to Sinhagad Fort treks. Khadakwasla is Pune’s refreshing natural escape for families and travelers alike."
  }
],



        "services": [
    {
      "name": "Pune Instant Cab Booking",
      "description": "Experience hassle-free, instant cab booking in Pune through our user-friendly platform. Get immediate confirmation and real-time updates, ensuring a swift pickup anytime, anywhere. Our fleet includes a variety of vehicle types to suit your needs, all driven by professional and courteous drivers dedicated to providing safe and comfortable rides."
    },
    {
      "name": "Pune Online Car Hire",
      "description": "Book cars online in Pune with ease and confidence. Choose from a wide selection of vehicles, from economy to luxury, all available for self-drive or chauffeur-driven options. Our online platform offers transparent pricing, multiple payment methods, and 24/7 customer support to make your car hire experience seamless and enjoyable."
    },
    {
      "name": "Pune Mobile Cab Booking",
      "description": "Book your Pune cab on-the-go with our mobile-friendly booking service. Whether using your smartphone or tablet, enjoy quick access to reliable cabs, easy payment options, and live ride tracking. Perfect for busy commuters and travelers who need quick, convenient transport solutions at their fingertips."
    },
    {
      "name": "Pune Online Taxi Reservations",
      "description": "Secure your taxi in Pune ahead of time with our online reservation system. Plan your trips with confidence, choose your preferred vehicle type, and enjoy transparent pricing with no hidden fees. Our reliable service ensures punctual pickups and safe journeys for all your travel needs."
    },
    {
      "name": "Pune Quick Cab Booking",
      "description": "Get a cab in minutes with Pune Quick Cab Booking. Designed for those last-minute rides or spontaneous trips, our fast booking system connects you to nearby drivers instantly. Enjoy competitive rates, clean vehicles, and professional drivers ready to take you anywhere within or around Pune city."
    },
    {
      "name": "Pune Online Ride Booking",
      "description": "Seamlessly book rides online in Pune with our intuitive platform. From local city travel to longer journeys, select your vehicle, choose your pickup and drop locations, and confirm your ride instantly. Benefit from upfront pricing, live driver tracking, and 24/7 customer assistance for an effortless booking experience."
    },
    {
      "name": "Pune Book Taxi Online",
      "description": "Conveniently book taxis online in Pune with our secure and user-friendly website. Enjoy multiple vehicle choices, instant fare estimates, and various payment methods including cashless options. Perfect for business travelers, tourists, and locals seeking reliable transportation at the click of a button."
    },
    {
      "name": "Pune Online Taxi Service",
      "description": "Our Pune Online Taxi Service offers a comprehensive, tech-driven approach to cab booking. Easily schedule rides, manage bookings, and track drivers via our app or website. We prioritize safety, punctuality, and customer satisfaction to provide the best possible taxi experience in Pune."
    },
    {
      "name": "Pune Online Cab Booking",
      "description": "Book cabs online in Pune anytime with our 24/7 service platform. Choose from hatchbacks, sedans, SUVs, and luxury vehicles to fit your trip and budget. Our streamlined booking process ensures quick confirmations, transparent pricing, and excellent customer support for smooth travels."
    },
    {
      "name": "Book Cab From Mumbai to Pune",
      "description": "Easily book a cab from Mumbai to Pune online with fixed pricing and trusted drivers. Enjoy door-to-door service with comfortable vehicles, ideal for business travelers, tourists, and commuters needing reliable intercity transport. Our online platform ensures hassle-free booking and timely pickups."
    },
    {
      "name": "Taxi Booking Pune",
      "description": "Effortlessly book taxis in Pune with our reliable service that offers a variety of vehicles suited for local travel, airport transfers, and outstation trips. Benefit from instant booking confirmations, competitive rates, and professional drivers committed to your safety and comfort."
    },
    {
      "name": "Online Taxi Booking Pune",
      "description": "Experience the convenience of online taxi booking in Pune with real-time driver availability, easy payment options, and seamless ride management. Whether for daily commutes or special occasions, our platform provides efficient, affordable, and reliable taxi services across the city."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Online Booking",
      "description": "Book your taxi online for smooth transfers from Mumbai Airport to Pune. Our service guarantees punctual pickups, clean vehicles, and professional chauffeurs ready to assist you with your luggage. Enjoy fixed rates and the convenience of pre-booking for stress-free airport commutes."
    },
    {
      "name": "Online Cab Booking Mumbai to Pune",
      "description": "Reserve your cab online for travel from Mumbai to Pune with ease and confidence. Choose from a variety of cars and pricing options with transparent fares. Our experienced drivers ensure a safe and comfortable journey, whether for business or leisure travel."
    },
    {
      "name": "Online Car Booking in Pune",
      "description": "Book cars online in Pune through our comprehensive platform offering a wide range of vehicles and flexible rental options. From quick city trips to extended journeys, enjoy seamless booking, competitive pricing, and reliable customer support to meet all your transportation needs."
    },
    {
      "name": "Online Cabs in Pune",
      "description": "Access online cab services in Pune with our platform that connects you instantly to nearby drivers. Benefit from easy bookings, upfront pricing, and options to pay digitally or by cash. Whether commuting daily or traveling occasionally, our online cabs provide a convenient solution."
    },
    {
      "name": "Online Cab Service in Pune",
      "description": "Our online cab service in Pune ensures fast, reliable, and safe rides with the convenience of digital booking and real-time tracking. Choose your vehicle type, schedule rides in advance or book instantly, and enjoy professional drivers dedicated to delivering excellent customer experiences."
    },
    {
      "name": "Online Taxi Pune",
      "description": "Book taxis online in Pune anytime with our secure, easy-to-use service. From solo rides to group travel, choose from a variety of car types and benefit from transparent pricing and driver ratings. Our platform guarantees timely pickups and smooth journeys across Pune."
    },
    {
      "name": "Taxi Booking in Pune",
      "description": "Book taxis across Pune effortlessly with our extensive network of verified drivers and fleet options. Whether it’s for airport runs, corporate travel, or sightseeing tours, enjoy competitive fares, instant booking confirmation, and dependable service with professional drivers."
    },
    {
      "name": "Pune to Shirdi Cab Booking Online",
      "description": "Plan your pilgrimage or trip with ease by booking cabs online from Pune to Shirdi. Our service offers comfortable vehicles, experienced drivers, and flexible schedules. Enjoy transparent pricing, door-to-door service, and options for one-way or round trips, making your journey pleasant and stress-free."
    }
  ],
  "tableData": [
    ["Pune Instant Cab Booking", "Pune Online Car Hire"],
    ["Pune Mobile Cab Booking", "Pune Online Taxi Reservations"],
    ["Pune Quick Cab Booking", "Pune Online Ride Booking"],
    ["Pune Book Taxi Online", "Pune Online Taxi Service"],
    ["Pune Online Cab Booking", "Book Cab From Mumbai to Pune"],
    ["Taxi Booking Pune", "Online Taxi Booking Pune"],
    ["Mumbai Airport to Pune Taxi Online Booking", "Online Cab Booking Mumbai to Pune"],
    ["Online Car Booking in Pune", "Online Cabs in Pune"],
    ["Online Cab Service in Pune", "Online Taxi Pune"],
    ["Taxi Booking in Pune", "Pune to Shirdi Cab Booking Online"]
  ],


     "whychoose": [
    {
        "WhyChooseheading": "Fast and Easy Pune Online Cab Booking",
        "WhyChoosedescription": "Platinum24 Cabs offers a seamless online booking platform for quick and hassle-free cab reservations in Pune."
    },
    {
        "WhyChooseheading": "Wide Range of Cabs Available at Your Fingertips",
        "WhyChoosedescription": "Choose from various vehicle types instantly via our online system to match your travel needs in Pune."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs for Your Protection",
        "WhyChoosedescription": "All vehicles booked online are thoroughly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "Our skilled drivers know Pune’s routes well, ensuring timely pickups and smooth rides."
    },
    {
        "WhyChooseheading": "Flexible Scheduling with Instant Confirmation",
        "WhyChoosedescription": "Book your cab anytime, anywhere, and get instant confirmation to fit your Pune travel plans."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our online booking system shows clear pricing, including all taxes and fees, so you pay exactly what you see."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, City Rides, and Business Trips",
        "WhyChoosedescription": "Whether it’s a quick city ride or an airport drop, our online booking service caters to all your needs."
    },
    {
        "WhyChooseheading": "24/7 Customer Support to Assist Your Booking",
        "WhyChoosedescription": "Our support team is available round-the-clock to help with online bookings and answer any questions."
    }
]













    }


  const faqData = [
    {
        question: 'Can I book a cab online with Platinum24 Cabs in Pune?',
        answer: 'Yes, Platinum24 Cabs offers easy and convenient online cab booking through our website and mobile app for Pune.',
    },
    {
        question: 'How do I make an online booking for a cab in Pune?',
        answer: 'Simply visit our website or download the Platinum24 Cabs app, select your pickup and drop locations, choose your vehicle, and confirm your booking.',
    },
    {
        question: 'Is online booking available 24/7 for Pune cabs?',
        answer: 'Yes, our online booking platform is available 24/7, allowing you to book a cab anytime according to your convenience.',
    },
    {
        question: 'Can I pay online for my cab booking in Pune?',
        answer: 'Absolutely! We support multiple online payment methods including credit/debit cards, UPI, and digital wallets for seamless transactions.',
    },
    {
        question: 'Can I cancel or modify my online cab booking?',
        answer: 'Yes, you can easily cancel or modify your booking through our website or app, subject to our cancellation policy.',
    },
    {
        question: 'Are there any discounts or offers on online bookings?',
        answer: 'We regularly provide discounts and promotional offers for online cab bookings. Check our app or website for current deals.',
    },
    {
        question: 'Is it safe to book a cab online with Platinum24 Cabs?',
        answer: 'Yes, our platform is secure and all drivers are verified to ensure a safe and reliable travel experience.',
    },
    {
        question: 'Can I track my cab after booking online?',
        answer: 'Yes, once your booking is confirmed, you can track your cab in real-time via our app or website.',
    },
    {
        question: 'Do I need to register to book a cab online?',
        answer: 'You can book as a guest or register for faster bookings and access to your ride history and exclusive offers.',
    },
    {
        question: 'Is online cab booking available for outstation trips from Pune?',
        answer: 'Yes, you can book outstation cabs online for popular destinations like Mumbai, Lonavala, and Goa through our platform.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arjun Deshpande',
        feedback: 'Booking a cab online with Platinum24 Cabs was super easy and convenient. The driver arrived on time and the ride was smooth.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Riya Kulkarni',
        feedback: 'I love the online booking system of Platinum24 Cabs. It’s user-friendly and the payment options make it hassle-free.',
        rating: 5,
    },
];





























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const puneOnlineCabBookingSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Online Cab Booking",
  "image": "https://www.platinum24cab.com/assets/images/pune-online-cab-booking.jpg",
  "description": "Platinum24 Cabs offers fast and reliable Pune online cab booking. Book taxis instantly for local, airport, and outstation travel. Easy mobile booking, 24/7 service, verified drivers, and multiple vehicle options.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "30500",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-online-cab-booking"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune Online Cab Booking | Instant Taxi Hire 24/7 | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Platinum24 Cabs offers fast and reliable Pune online cab booking. Book taxis instantly for local, airport, and outstation travel. Easy mobile booking, 24/7 service, verified drivers, and multiple vehicle options."
  />
  <meta
    name="keywords"
    content="Pune Instant Cab Booking, Pune Online Car Hire, Pune Mobile Cab Booking, Pune Online Taxi Reservations, Pune Quick Cab Booking, Pune Online Ride Booking, Pune Book Taxi Online, Pune Online Taxi Service, Pune Online Cab Booking, Book Cab From Mumbai to Pune, Taxi Booking Pune, Online Taxi Booking Pune, Mumbai Airport to Pune Taxi Online Booking, Online Cab Booking Mumbai to Pune, Online Car Booking in Pune, Online Cabs in Pune, Online Cab Service in Pune, Online Taxi Pune, Taxi Booking in Pune, Pune to Shirdi Cab Booking Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneOnlineCabBookingSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneonlinecabbooking;